import { render } from "./MyWish.vue?vue&type=template&id=2ffc94b5"
import script from "./MyWish.vue?vue&type=script&lang=js"
export * from "./MyWish.vue?vue&type=script&lang=js"

import exportComponent from "C:\\jhj\\applemarket\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__